import styled from '@emotion/styled';
import Link from 'client/components/Link';
import { StyledNavLink } from '../../LinkStyles';

const SMALL_WINDOW_HEIGHT = 500;

export const MarketingAppButtonsContainer = styled.div`
  margin-bottom: 2vh;
  @media (max-height: ${SMALL_WINDOW_HEIGHT}px) {
    display: none;
  }
`;

export const BadgeContainer = styled.div`
  position: absolute;
  top: 0;
  right: -10px;
`;

export const PrimaryLink = styled(StyledNavLink)<{ isActive: boolean }>`
  font-size: 1.75rem !important;
  line-height: 1.2;
`;

export const SecondaryLink = styled(PrimaryLink)<{ isActive: boolean }>`
  font-weight: normal;
  font-size: 1.25rem !important;
`;

export const AnchorWrapper = styled.span`
  position: relative;
`;

export const Nav = styled.nav`
  position: relative;
  display: grid;
  grid-auto-flow: row;
  grid-gap: 2vh;

  @media (max-height: ${SMALL_WINDOW_HEIGHT}px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    a {
      margin-right: 10px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0;
`;

export const MobileNavContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  width: 100%;
  height: 100vh;
  height: 100vh;
  padding: 26px;
  padding-top: 18px;
  overflow: hidden;
  background-color: #24203f;
`;

export const MobileNavContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 80%;
`;

export const MobileNavTopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledIconLink = styled(Link)`
  position: relative;
  width: 35px;
`;

export const MobileNavClosedButton = styled.button<{ on: string }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-top: -12px;
  margin-right: -12px;
  padding: 0;
`;

export const MobileNavCloseLine = styled.span`
  position: absolute;
  display: block;
  width: 20px;
  height: 1px;
  background: white;

  &.close-line-one {
    transform: rotate(45deg);
  }

  &.close-line-two {
    transform: rotate(-45deg);
  }
`;

export const MobileNavButtonContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 2vh;
  align-content: flex-end;
`;
